// extracted by mini-css-extract-plugin
export default {"products":"Xz-z","card":"Yz-z","oosMessaging":"Zz-z"};